<template>
  <div class="main-nav">
    <PlayMenu v-if="$store.getters.user_has_flag('POKERWIZ')" />
    <StudyMenu />
    <PracticeMenu />
    <AnalyzeMenu />
  </div>
</template>

<script>
import PlayMenu from '@/components/AppBar/PlayMenu'
import PracticeMenu from '@/components/AppBar/PracticeMenu'
import AnalyzeMenu from '@/components/AppBar/AnalyzeMenu'
import StudyMenu from '@/components/AppBar/StudyMenu'

export default {
  name: 'MainNav',
  components: {
    PlayMenu,
    StudyMenu,
    PracticeMenu,
    AnalyzeMenu,
  },
}
</script>
<style lang="scss" scoped>
.main-nav {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
